export default __webpack_public_path__ + "static/media/cp_geo_nu.dbff3333.svg";